import React, { lazy, Suspense } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import RootLayout from "@/layouts/RootLayout";
import PublicLayout from "@/layouts/PublicLayout";

const ProtectedLayout = lazy(() => import("@/layouts/ProtectedLayout"));
const DashboardLayout = lazy(() => import("@/layouts/DashboardLayout"));
const Login = lazy(() => import("@/pages/Login"));
const LoginEmailStep = lazy(() => import("@/pages/LoginEmailStep"));
const LoginPasskeyStep = lazy(() => import("@/pages/LoginPasskeyStep"));
const LoginPasswordStep = lazy(() => import("@/pages/LoginPasswordStep"));
const Signup = lazy(() => import("@/pages/Signup"));
const ForgotPassword = lazy(() => import("@/pages/ForgotPassword"));
const VerifyEmail = lazy(() => import("@/pages/VerifyEmail"));
const VerifyCode = lazy(() => import("@/pages/VerifyCode"));
const AreaCode = lazy(() => import("@/pages/AreaCode"));
const PortNumber = lazy(() => import("@/pages/PortNumber"));
const SubscribeSuccess = lazy(() => import("@/pages/SubscribeSuccess"));
const Payment = lazy(() => import("@/pages/Checkout"));
const AddCredit = lazy(() => import("@/pages/AddCredit"));
const PurchaseEsim = lazy(() => import("@/pages/PurchaseEsim"));
const AccountManage = lazy(() => import("@/components/AccountManage"));
const Chats = lazy(() => import("@/components/Chats"));
const Voicemail = lazy(() => import("@/components/Voicemail"));
const ManagePlans = lazy(() => import("@/components/ManagePlans"));
const Calls = lazy(() => import("@/components/Calls"));
const EsimManage = lazy(() => import("@/components/EsimManage"));
const PickPlan = lazy(() => import("@/pages/PickPlan"));
const DownloadApp = lazy(() => import("@/pages/DownloadApp"));
const ChoosePrivatePlan = lazy(() => import("@/pages/ChoosePrivatePlan"));
const ChooseEsimPlan = lazy(() => import("@/pages/ChooseEsimPlan"));

const routeFallback = <div style={{ minHeight: "calc(100vh - 90px)" }} />;

const AppRouter = () => {
    return (
        <BrowserRouter basename="/app">
            <Suspense fallback={routeFallback}>
                <Routes>
                    <Route element={<RootLayout />}>
                        <Route element={<PublicLayout />}>
                            <Route path="/login" element={<Login />} />
                            <Route path="/login/email" element={<LoginEmailStep />} />
                            <Route path="/login/passkey" element={<LoginPasskeyStep />} />
                            <Route path="/login/password" element={<LoginPasswordStep />} />
                            <Route path="/register" element={<Signup />} />
                            <Route path="/verify-email" element={<VerifyEmail />} />
                            <Route path="/verify-code" element={<VerifyCode />} />
                            <Route path="/download" element={<DownloadApp />} />
                            <Route path="/forgot-password" element={<ForgotPassword />} />
                            <Route path="/" element={<Navigate to="/login" replace />} />
                        </Route>

                        <Route element={<ProtectedLayout />}>
                            <Route path="/pick-plan" element={<PickPlan />} />
                            <Route path="/area-code" element={<AreaCode />} />
                            <Route path="/port-number" element={<PortNumber />} />
                            <Route path="/subscribe_success" element={<SubscribeSuccess />} />
                            <Route path="/checkout" element={<Payment />} />
                            <Route path="/add-credit" element={<AddCredit />} />
                            <Route path="/pricing-page" element={<ChoosePrivatePlan />} />
                            <Route path="/choose-esim" element={<ChooseEsimPlan />} />
                            <Route path="/purchase-esim" element={<PurchaseEsim />} />

                            <Route path="/dashboard" element={<DashboardLayout />}>
                                <Route index element={<Navigate to="account" replace />} />
                                <Route path="account" element={<AccountManage />} />
                                <Route path="chats" element={<Chats />} />
                                <Route path="voicemails" element={<Voicemail />} />
                                <Route path="plan" element={<ManagePlans />} />
                                <Route path="esim" element={<EsimManage />} />
                                <Route path="calls" element={<Calls />} />
                            </Route>
                        </Route>
                        <Route path="*" element={<Navigate to="/login" replace />} />
                    </Route>
                </Routes>
            </Suspense>
        </BrowserRouter>
    );
};

export default AppRouter;
